import {
  type AreaData,
  type AreaGetInput,
  type AreaGetSuccess,
  type AreaId,
  DAY,
  isDefined,
  MINUTE,
} from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { type TinyQueryOptions, useTantalimQuery } from '../query'
import { areaGetKey } from '../keys'
import { type GetHookResponse } from '../hooks'
import { findListedArea } from './cacheSync'

export type AreaGetOptions = TinyQueryOptions & {
  /** Show the area's copy from a cached v2 area list while /area/get loads. */
  placeholderFromLists?: boolean
}

const EMPTY_AREA_ID: AreaId = 'Area.EMPTY_AREA'
export function useArea(
  areaId: AreaId | undefined,
  { placeholderFromLists = false, ...options }: AreaGetOptions = {}
): GetHookResponse<AreaData> {
  const queryClient = useQueryClient()
  const input: AreaGetInput = { areaId: areaId ?? EMPTY_AREA_ID }
  const placeholderData =
    placeholderFromLists && isDefined(areaId)
      ? (): AreaData | undefined => findListedArea(queryClient, areaId)
      : undefined
  return useTantalimQuery<AreaGetInput, AreaGetSuccess, AreaData>({
    url: '/area/get',
    queryKey: areaGetKey(areaId),
    input,
    convertResponse: (data) => data.area,
    options: {
      gcTime: DAY,
      staleTime: MINUTE,
      ...options,
      placeholderData,
      enabled: isDefined(areaId) && (options.enabled ?? true),
    },
  })
}
